import React, {useState} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import GlobalState, { changepopupdeleteColumn, setEvery, setHour, setMinut, changepopupdeleteShedule, changePortraitsheduledeploycred, changeActivePortraits, changePortraitsheduledeployname, changePortraitsheduledeploynameAll, changesegmentationpagecenter1} from "../../../stores/GlobalState";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"

const PopupDeleteWorkspace = observer(() =>{

    async function updateDataPortrait()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `portraits/table?page=1&limit=10`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            if(data?.deploymentInfo){
                if(data?.deploymentInfo[0])
                {
                    changePortraitsheduledeploynameAll(data?.deploymentInfo[0]?.bigquery_table_name, data?.deploymentInfo[0]?.periodicity, data?.deploymentInfo[0]?.start_time, data?.deploymentInfo[0]?.id) 
                }
            }
            changesegmentationpagecenter1(1);
            changepopupdeleteShedule();
            changePortraitsheduledeployname("");
            changeActivePortraits(data);
            setEvery('');
            setHour('01')
            setMinut("00");

        }
        
    }
    const deleteproductline = async () => {
        var token = localStorage.getItem("token");
        const response = await fetch( Domen.url + `portraits/table/deploy/bigquery/schedule/`+GlobalState.segmentsheduleid, {
            method: 'DELETE',
            headers: {
              'Authorization': token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
        });
        
        if(response.status>=200&&response.status<400)
        {
            setTimeout(function(){
                updateDataPortrait()
            }, 500);
            
        }
        
    };
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    return (
        <div className="popupInfofon ">
            <div className="popupInfo deleteProduct">
                <div className='top-element'>
                    {/* <div className='separator'></div> */}
                    <div></div>
                    <div className='buttonspopup'>
                        <div className='buttonexit' onClick={changepopupdeleteShedule}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='form-element'>
                    <div className='titlePopupDelete' >
                        Are You sure that you want <br/> <span>To delete export schedule?</span>
                        
                    </div>
                    <div className='buttonsPopupDelete'>
                        <div className='buttonPopupDelete_select' onClick={changepopupdeleteShedule}>
                            {langv?.groupsettings?.popupdeleteproduct?.text2}
                        </div>
                        <div className='buttonPopupDelete_select active' onClick={() =>deleteproductline()}>
                            {langv?.groupsettings?.popupdeleteproduct?.text3}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PopupDeleteWorkspace;
